import { createContext, useContext } from "react";

export const TableFilterWrapperContext = createContext<boolean>(false);

export const useIsInsideTableFilterWrapper = (): boolean =>
  useContext(TableFilterWrapperContext);
